module.exports = __webpack_public_path__ + "img/bio.134807ee.svg";